<template>
  <div class="case-detail">
    <div class="detail-inner global-margin">
      <el-breadcrumb separator=">" class="breadcrumb  ">
        <el-breadcrumb-item to="/industryPavilionCase">{{ $t("case.p7") }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{
          productInfo.trans && productInfo.trans.title
        }}</el-breadcrumb-item>
      </el-breadcrumb>
      <video :alt="productInfo.trans.desc" autoplay="autoplay" muted="muted" objectfit="contain"
        :src="productInfo.video" v-if="productInfo.video" controls="controls"></video>
      <div class="desc" v-if="productInfo.trans && productInfo.trans.desc">
        {{ productInfo.trans && productInfo.trans.desc }}
      </div>
      <div class="card-box wangeditor" v-html="content" ref="cardbox" v-if="showcontent">
      </div>
      <Sapar :swidth="swidth" :imgInfo="imgInfo" />
      <Sapar2 :swidth="swidth" />
    </div>
  </div>
</template>

<script>
import Sapar from "./components/Sapar.vue";
import Sapar2 from "./components/Sapar2.vue";
export default {
  name: "detail",
  props: {
    swidth: {
      type: Number
    }
  },
  data() {
    return {
      productInfo: {},
      imgInfo: [],
      loading: false,
      video: "",
      shower: false,
      content: '',
      showcontent: false
    };
  },
  components: { Sapar, Sapar2 },
  created() {
    this.getProductInfo();
  },
  methods: {
    //  获取案例明细
    getProductInfo() {
      this.loading = true;
      this.$http
        .get("/api/cases/info?id=" + this.$route.query.id)
        .then((res) => {
          if (res.code == 200) {
            this.productInfo = res.data;
            this.content = res.data.trans.content
            this.setVideoCss()
            this.imgInfo = res.data.img_list;
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    setVideoCss() {
      let that = this
      this.$nextTick(() => {
        let cardbox = that.$refs.cardbox;
        if (cardbox) {
          // Access and modify element properties
          const videos = cardbox.getElementsByTagName('video');
          Array.from(videos).forEach(video => {
            let origin_width = video.width
            video.style.width = `${origin_width}%`;
            // video.style.width = '100%';
            // video.style.height = 'auto';
            // video.style.maxWidth = '1200px';
            video.style.margin = 'auto';
            video.style.display = 'flex';
            video.autoplay = 'autoplay'
            video.muted = 'muted'
            // video.objectfit = 'contain'
          });
          this.showcontent = true
        }
      })
    }
  },
  watch: {
    $route() {
      this.getProductInfo();
    },
  },
};
</script>

<style lang="less" scoped>
.case-detail {
  background-color: #f1f1f1;
  padding: 80px 16px 20px;

  .detail-inner {
    margin-top: 30px;
    // margin-bottom: 20px;
    padding: 20px 30px;
    background: #fff;
    border-radius: 5px;
  }

  .breadcrumb {
    font-family: SourceHanSansCN-Light;
    font-size: 22px;
    line-height: 34px;
    color: #333333;
    margin-bottom: 20px;
  }

  video {
    width: 100%;
    margin-bottom: 10px;
  }

  .desc {
    font-size: 20px;
    font-weight: 300;
    color: #666;
    padding-bottom: 10px;
  }

  .card-box {
    width: 100%;
  }

  /deep/.is-link {
    font-weight: 400;
    color: #606266;
  }
}


.recommend-box {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/caseDetails/detail.vue